export const TIPS_STORAGE_KEY = 'tipsEnabled';
export const TIPS_CHANGED_EVENT = 'upscale:tips-changed';

export function isTipsEnabled() {
  try {
    return localStorage.getItem(TIPS_STORAGE_KEY) !== 'false';
  } catch {
    return true;
  }
}

export function setTipsEnabled(enabled) {
  try {
    localStorage.setItem(TIPS_STORAGE_KEY, enabled ? 'true' : 'false');
  } catch {
    // stockage indisponible (navigation privée) : la préférence vit le temps de la session
  }
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(TIPS_CHANGED_EVENT, { detail: { enabled } }));
  }
}

export function subscribeTipsChanged(listener) {
  if (typeof window === 'undefined') return () => {};
  const handler = (event) => listener(Boolean(event.detail?.enabled));
  window.addEventListener(TIPS_CHANGED_EVENT, handler);
  return () => window.removeEventListener(TIPS_CHANGED_EVENT, handler);
}
